"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ClientAddress_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAddress = void 0;
const typeorm_1 = require("typeorm");
const Address_1 = require("../../shared/entity/Address");
// eslint-disable-next-line import/no-cycle
const Client_1 = require("./Client");
const CircularReference_1 = require("../../serialization/CircularReference");
let ClientAddress = ClientAddress_1 = class ClientAddress extends Address_1.Address {
    static forClient(client) {
        const address = new ClientAddress_1();
        address.client = client;
        return address;
    }
};
exports.ClientAddress = ClientAddress;
__decorate([
    (0, typeorm_1.ManyToOne)(() => Client_1.Client, (client) => client.addresses),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Client_1.Client)
], ClientAddress.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.RelationId)((c) => c.client),
    __metadata("design:type", String)
], ClientAddress.prototype, "clientId", void 0);
exports.ClientAddress = ClientAddress = ClientAddress_1 = __decorate([
    (0, typeorm_1.Entity)()
], ClientAddress);
